<div class="days-row">
  <div class="days-row__item" *ngFor="let dayInMonth of daysInMonth; let day = index">
    <app-selectable-card
      [id]="'day-' + (day + 1)"
      [text]="day + 1"
      [selected]="days.includes(day + 1)"
      (click)="toggleDay(day + 1)">
    </app-selectable-card>
  </div>
</div>